import React from "react";
import {
    Link,
    useRouteMatch
} from "react-router-dom";
import PropTypes from "prop-types";

function TabBarLink({ to, title, icon, exact = false, hidden = false, onClick }) {
    let match = useRouteMatch({
        path: to,
        exact: exact
    });
    let className = "nav-item" + (match ? " active" : "") + (hidden ? " d-none" : "");
    return (
        <li className={ className }>
            <Link to={ to } className="nav-link tabbar-link" onClick={ onClick }>
                { icon && (
                    <i className={ "tabbar-icon " + icon }></i>
                )}
                <span>
                    { title }
                </span>
            </Link>
        </li>
    );
}
TabBarLink.propTypes = {
    to: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    icon: PropTypes.string,
    exact: PropTypes.bool,
    hidden: PropTypes.bool,
    onClick: PropTypes.func
};

export default React.memo(TabBarLink);
